module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-iii/bg-03-4e80122eb88889bfbf81a05a8ed0875b.png";